<template>
    <div class="root">
        <div class="button material-button">
            <p>
                Printed<br />
                Material<br />
                Backdrop
            </p>
        </div>
        <div class="size">
            <h2>Enter required size below:-</h2>
            <label>Width</label>
            <input type="text" v-model="width">
            <div class="note">in mm</div>
            <br />
            <label>Height</label>
            <input type="text" v-model="height">
            <div class="note">in mm</div>
            <br />
            <button @click="selectImage">Search for an Image</button>
            <div class="cost" v-html="costHTML"></div>
        </div>
        
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data: function(){
        return{
            width: '2000',
            height: '2000',
            cost: 0,
            costHTML: '',
        }
    },
    methods:{
        selectImage: function(){
            
            this.$store.commit( 'setSize', {
                width: this.width,
                height: this.height,
            })

            this.$store.commit( 'setCost', {
                cost: this.cost,
            })
            
            this.$router.push( '/printed-material-images' )
        },
        updateCosts:function(){
            var sqm = ( this.width / 1000 ) * ( this.height/ 1000 )

            var baseCost = 20
            var sqmCost = 30

            var cost = baseCost + ( sqmCost * sqm )

            this.cost = cost.toFixed(2)

            this.$store.commit( 'setCost', {
                cost: this.cost,
            })
            this.$store.commit( 'setSize', {
                width: this.width,
                height: this.height,
            })
            
            this.costHTML = '&pound;' + cost.toFixed(2);
        }
    },
    computed:mapGetters([
        'getCurrentProduct', 
    ]),
    created:function(){
        this.$store.commit( 'enablePopularSearches' )
        this.updateCosts()
    },
    watch:{
        width: function(){this.updateCosts()},
        height: function(){this.updateCosts()},
    }
}
</script>

<style scoped>
    .root{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 32rem;
    }

    .button{
        position: relative;
        background: no-repeat;
        background-position: center;
        background-size: cover;
        height: 325px;
        width: 325px;
        border-radius: 1rem;
        box-shadow: 1rem 1rem 2rem rgba(0,0,0,0.5);
    }

    .button p{
        font-size: 3rem;
        font-weight: 700;
        color: rgb( 50, 50, 50 );
        left: 3.5rem;
        top: 2rem;
        position: absolute;
    }

    .material-button{
        background-image: url( /images/icon-printed-material.jpg );
    }

    .size{
        right: calc(50% - 525px);
        margin-right: 3rem;
        color: white;
    }

    .size h2{
        font-size: 3rem;
        margin: 2rem 0 1rem 0;
    }

    .size label{
        font-size: 2rem;
        display: inline-block;
        width: 7rem;
        margin-right: 2rem;
        margin-top: 2rem;
        text-align: right;
    }

    .size input{
        font-size: 2rem;
        padding: 1rem;
    }

    .size .note{
        display: inline;
        font-size: 1.5rem;
        padding: 1rem;
    }

    .size button{
        font-size: 2rem;
        border: none;
        padding: 1rem;
        background-color: white;
        font-weight: 700;
        margin-top: 1rem;
        float: right;
    }

    .cost{
        font-size: 3rem;
        padding: 1.5rem;
    }



</style>